export function isNavItemActive(pathname, item) {
    const [currentPath = "", currentQuery = ""] = pathname.split("?");
    const [itemPath = "", itemQuery = ""] = item.href.split("?");
    const pathMatches = currentPath === itemPath ||
        (item.exact !== true && currentPath.startsWith(`${itemPath}/`));
    if (!pathMatches)
        return false;
    const currentParams = new URLSearchParams(currentQuery);
    return [...new URLSearchParams(itemQuery)].every(([key, value]) => currentParams.get(key) === value);
}
//# sourceMappingURL=navigation.js.map